import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getHomeCategoryData } from '../../../Redux/action/MasterAction';
import AOS from "aos";
import Aos from 'aos';
const host = process.env.REACT_APP_API_SERVER
const CourseCategory = () => {
    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(getHomeCategoryData())
    }, []);

   


    const {

        loadingCategoryDataListApi,
        CategoryDataListApiData,
        CategoryDataListApiError

    } = useSelector(state => state?.MasterReducer);

    const fallbackImages = [
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-01.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-02.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-03.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-04.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-05.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-06.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-07.jpg',
        'https://mentoring.dreamstechnologies.com/html/template/assets/img/course/course-08.jpg',
    ];

    function getRandomFallbackImage() {
        return fallbackImages[Math.floor(Math.random() * fallbackImages.length)];
    }

    useEffect(function () {
        Aos.init({ duration: 1000 });
      }, []);

    return (
        <section className="section path-section-eight" data-aos="fade-up">
            <div
                className="section-header-eight text-center"
                
            >
                <div className="container">
                    <div className="heading ">
                        <span className="ruby section-badge">
                         
                            CATEGORY
                           
                        </span>
                    </div>
                </div>
            </div>
            <div className="sec-dots">
                <span />
                <span />
                <span />
            </div>
            <div className="course-sec" >
                <div className="container">
                    <div className="row justify-content-center">
                        {CategoryDataListApiData?.slice(0, 12)?.map((data) => (
                            <div
                                className="col-12 col-md-4 col-lg-3"
                                
                            >
                                <div className="course-item">
                                    <a className="course-img">
                                        <div className="image-col-merge">
                                            <img
                                                src={`${host}${data?.image}`}
                                                onError={(e) => (e.target.src = getRandomFallbackImage())}
                                            />
                                            <div className="course-text">
                                                <h5>{data?.other_name ? data?.other_name : data?.name}</h5>
                                                <div className="d-flex justify-content-between">
                                                    <p>{data?.tutorCount} Tutors</p>
                                                    <p>{data?.subCategoryCount} Subjects</p>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        ))}

                    </div>
                   
                </div>
            </div>
        </section>
    )
}

export default CourseCategory